module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_LogIn_16"],"path":[{"$":{"d":"M11,15H1V1H11V4H9V3H3V13H9V12h2ZM4,8l4,3V9h7V7H8V5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_LogIn_16.svg
// module id = SQjw
// module chunks = 1